import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'getm-add-another-promo-row',
  templateUrl: './add-another-promo-row.component.html',
  styleUrls: ['./add-another-promo-row.component.scss']
})
export class AddAnotherPromoRowComponent implements AfterViewInit {

  @Input() maximum: number = 0;
  @Input() minimum: number = 0;
  @Input() selected: number = 0;

  @Output() selectedAddPromo = new EventEmitter<number>();

  private initialSelected: number = 0;

  constructor() { }

  ngAfterViewInit(): void {
    this.initialSelected = this.selected;
  }

  public onQuantityChange = (quantity: number): void => {
    this.selected = quantity;
    this.selectedAddPromo.emit(this.selected);
  };

  public onRemoveProduct = (): void => {
    this.selected = this.initialSelected;
    this.selectedAddPromo.emit(this.selected);
  };
}
